{
  "level": "sub05",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:sub05",
    "objects": "AREAS.E3:sub05.e3",
    "mesh": "TREES.E3:sub05.e3"
  },
  "spawn_point": {
    "position": [
      1282.6689666748048,
      -2376.1504697602372,
      591.475341796875
    ],
    "facing_rad": 0.0,
    "look_point": [
      1282.6689666748048,
      -2276.1504697602372,
      591.475341796875
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -272.79998779296875,
      -2491.5078125,
      567.475341796875
    ],
    "bbox_max": [
      1957.47509765625,
      -1912.37548828125,
      611.3209838867188
    ],
    "vertex_count": 145,
    "vertices": [
      [
        -208.0314483642578,
        -2406.307373046875,
        589.5012817382812
      ],
      [
        -198.0314483642578,
        -2406.307373046875,
        589.5012817382812
      ],
      [
        -198.0314483642578,
        -2406.307373046875,
        589.5012817382812
      ],
      [
        -198.0314483642578,
        -2375.548095703125,
        577.501220703125
      ],
      [
        -198.0314483642578,
        -2360.5,
        577.501220703125
      ],
      [
        -198.0314483642578,
        -2371.5,
        577.501220703125
      ],
      [
        -208.0314483642578,
        -2375.548095703125,
        577.501220703125
      ],
      [
        -208.0314483642578,
        -2406.307373046875,
        589.5012817382812
      ],
      [
        -208.0314483642578,
        -2360.5,
        577.501220703125
      ],
      [
        -208.0314483642578,
        -2371.5,
        577.501220703125
      ],
      [
        -198.0314483642578,
        -2375.548095703125,
        577.501220703125
      ],
      [
        -208.0314483642578,
        -2375.548095703125,
        577.501220703125
      ],
      [
        1647.772216796875,
        -2370.014404296875,
        609.4441528320312
      ],
      [
        1898.055908203125,
        -2063.52734375,
        593.4994506835938
      ],
      [
        1898.055908203125,
        -2063.52734375,
        593.4994506835938
      ],
      [
        1928.25927734375,
        -1976.9312744140625,
        577.501220703125
      ],
      [
        1928.25927734375,
        -1976.9312744140625,
        577.501220703125
      ],
      [
        1957.47509765625,
        -1912.37548828125,
        567.4754638671875
      ],
      [
        1690.7982177734375,
        -2317.615478515625,
        593.4994506835938
      ],
      [
        1647.9871826171875,
        -2369.956787109375,
        609.444091796875
      ],
      [
        1893.97705078125,
        -2104.87451171875,
        577.501220703125
      ],
      [
        1912.4505615234375,
        -2080.4091796875,
        567.4754638671875
      ],
      [
        1647.9871826171875,
        -2369.956787109375,
        609.444091796875
      ],
      [
        1893.97705078125,
        -2104.87451171875,
        577.501220703125
      ],
      [
        1690.7982177734375,
        -2317.615478515625,
        593.4994506835938
      ],
      [
        1759.8773193359375,
        -2258.0986328125,
        577.501220703125
      ],
      [
        1901.0638427734375,
        -2122.905029296875,
        567.4754638671875
      ],
      [
        1823.508544921875,
        -2241.048583984375,
        577.501220703125
      ],
      [
        1780.740234375,
        -2293.515380859375,
        593.4994506835938
      ],
      [
        1759.8773193359375,
        -2258.0986328125,
        577.501220703125
      ],
      [
        1817.2216796875,
        -2217.03466796875,
        567.4754638671875
      ],
      [
        1836.628173828125,
        -2211.834716796875,
        567.4754638671875
      ],
      [
        1823.508544921875,
        -2241.048583984375,
        577.501220703125
      ],
      [
        1448.085693359375,
        -2416.5556640625,
        593.4994506835938
      ],
      [
        1667.2535400390625,
        -2350.72216796875,
        577.501220703125
      ],
      [
        1695.5682373046875,
        -2338.68798828125,
        567.4754638671875
      ],
      [
        1714.9764404296875,
        -2333.486328125,
        567.4754638671875
      ],
      [
        1730.89013671875,
        -2333.6669921875,
        577.501220703125
      ],
      [
        1667.2535400390625,
        -2350.72216796875,
        577.501220703125
      ],
      [
        1730.89013671875,
        -2333.6669921875,
        577.501220703125
      ],
      [
        1734.48388671875,
        -2339.771728515625,
        593.4994506835938
      ],
      [
        1733.44921875,
        -2338.083984375,
        589.0087280273438
      ],
      [
        1448.085693359375,
        -2416.5556640625,
        593.4994506835938
      ],
      [
        1448.7994384765625,
        -2416.392578125,
        593.4358520507812
      ],
      [
        1667.135986328125,
        -2350.83984375,
        577.501220703125
      ],
      [
        1695.38232421875,
        -2338.8740234375,
        567.4754638671875
      ],
      [
        1667.135986328125,
        -2350.83984375,
        577.501220703125
      ],
      [
        1714.7979736328125,
        -2333.664794921875,
        567.4754638671875
      ],
      [
        1730.7977294921875,
        -2333.759521484375,
        577.501220703125
      ],
      [
        1730.7977294921875,
        -2333.759521484375,
        577.501220703125
      ],
      [
        1413.7203369140625,
        -2462.236572265625,
        611.3209838867188
      ],
      [
        1448.587646484375,
        -2457.56298828125,
        609.4977416992188
      ],
      [
        1413.72021484375,
        -2462.236572265625,
        611.3209838867188
      ],
      [
        1522.7379150390625,
        -2440.57373046875,
        602.8696899414062
      ],
      [
        1448.587646484375,
        -2457.56298828125,
        609.4977416992188
      ],
      [
        1627.916015625,
        -2416.5556640625,
        593.4994506835938
      ],
      [
        1522.7379150390625,
        -2440.57373046875,
        602.8696899414062
      ],
      [
        1668.5718994140625,
        -2405.610595703125,
        593.3786010742188
      ],
      [
        1627.916015625,
        -2416.5556640625,
        593.4994506835938
      ],
      [
        1628.760986328125,
        -2416.281982421875,
        593.3926391601562
      ],
      [
        1668.7442626953125,
        -2405.511474609375,
        593.4994506835938
      ],
      [
        1668.5718994140625,
        -2405.610595703125,
        593.3786010742188
      ],
      [
        1518.2481689453125,
        -2400.524658203125,
        587.2452392578125
      ],
      [
        1627.234130859375,
        -2375.548095703125,
        577.501220703125
      ],
      [
        1518.2481689453125,
        -2400.524658203125,
        587.2452392578125
      ],
      [
        1684.4063720703125,
        -2349.849853515625,
        567.4754638671875
      ],
      [
        1651.5194091796875,
        -2369.982666015625,
        575.3298950195312
      ],
      [
        1698.6129150390625,
        -2349.849853515625,
        567.4754638671875
      ],
      [
        1711.6611328125,
        -2352.896240234375,
        577.501220703125
      ],
      [
        1694.7952880859375,
        -2360.06494140625,
        571.460693359375
      ],
      [
        1711.6611328125,
        -2352.896240234375,
        577.501220703125
      ],
      [
        1711.5069580078125,
        -2353.05029296875,
        577.501220703125
      ],
      [
        1734.4486083984375,
        -2339.80712890625,
        593.4994506835938
      ],
      [
        1627.234130859375,
        -2375.548095703125,
        577.501220703125
      ],
      [
        1648.0738525390625,
        -2370.10693359375,
        577.3750610351562
      ],
      [
        1628.8983154296875,
        -2375.2431640625,
        577.3822021484375
      ],
      [
        1711.08544921875,
        -2353.22998046875,
        577.3506469726562
      ],
      [
        1694.74560546875,
        -2360.197998046875,
        571.5125732421875
      ],
      [
        1651.2801513671875,
        -2370.129150390625,
        575.3870239257812
      ],
      [
        1648.0738525390625,
        -2370.10693359375,
        577.3750610351562
      ],
      [
        1711.5069580078125,
        -2353.05029296875,
        577.501220703125
      ],
      [
        1689.0089111328125,
        -2375.54833984375,
        577.501220703125
      ],
      [
        1667.4888916015625,
        -2403.734619140625,
        588.49755859375
      ],
      [
        1667.4888916015625,
        -2403.734619140625,
        588.49755859375
      ],
      [
        1689.0089111328125,
        -2375.54833984375,
        577.501220703125
      ],
      [
        1648.920654296875,
        -2371.573486328125,
        575.9505615234375
      ],
      [
        1648.920654296875,
        -2371.573486328125,
        575.9505615234375
      ],
      [
        1673.3646240234375,
        -2375.098388671875,
        567.4754638671875
      ],
      [
        1693.5513916015625,
        -2363.39306640625,
        572.7591552734375
      ],
      [
        -198.0314483642578,
        -2434.0,
        597.5145263671875
      ],
      [
        -208.0314483642578,
        -2434.0,
        597.5145263671875
      ],
      [
        -172.5685577392578,
        -2434.0,
        597.5145263671875
      ],
      [
        -198.0314483642578,
        -2434.0,
        597.5145263671875
      ],
      [
        -208.0314483642578,
        -2434.0,
        597.5145263671875
      ],
      [
        -272.79998779296875,
        -2434.0,
        597.5145263671875
      ],
      [
        -272.79998779296875,
        -2434.0,
        597.5145263671875
      ],
      [
        -272.79998779296875,
        -2438.72705078125,
        593.4994506835938
      ],
      [
        -272.79998779296875,
        -2438.72705078125,
        593.4994506835938
      ],
      [
        -172.5685577392578,
        -2434.0,
        597.5145263671875
      ],
      [
        -172.5685577392578,
        -2438.72705078125,
        593.4994506835938
      ],
      [
        -172.5685577392578,
        -2438.72705078125,
        593.4994506835938
      ],
      [
        1625.6279296875,
        -2375.916259765625,
        577.6448364257812
      ],
      [
        1693.53076171875,
        -2363.448486328125,
        572.78076171875
      ],
      [
        1360.2275390625,
        -2469.3671875,
        567.475341796875
      ],
      [
        1422.333740234375,
        -2461.086669921875,
        574.50830078125
      ],
      [
        1365.359375,
        -2438.72705078125,
        593.4994506835938
      ],
      [
        1447.579345703125,
        -2416.7197265625,
        593.5634765625
      ],
      [
        1365.359375,
        -2438.72705078125,
        593.4994506835938
      ],
      [
        1365.9083251953125,
        -2438.6201171875,
        593.5902099609375
      ],
      [
        1448.5880126953125,
        -2457.56298828125,
        577.501220703125
      ],
      [
        1422.333740234375,
        -2461.086669921875,
        574.50830078125
      ],
      [
        1448.5880126953125,
        -2457.56298828125,
        577.501220703125
      ],
      [
        1495.9892578125,
        -2448.29248046875,
        585.3750610351562
      ],
      [
        1545.1539306640625,
        -2438.72705078125,
        593.4994506835938
      ],
      [
        1495.9892578125,
        -2448.29248046875,
        585.3750610351562
      ],
      [
        1545.1539306640625,
        -2438.72705078125,
        593.4994506835938
      ],
      [
        1626.72509765625,
        -2416.82763671875,
        593.6055297851562
      ],
      [
        1545.366455078125,
        -2438.6357421875,
        593.5770874023438
      ],
      [
        1667.578125,
        -2403.61767578125,
        588.4519653320312
      ],
      [
        1561.384521484375,
        -2431.74853515625,
        599.4266967773438
      ],
      [
        1401.2049560546875,
        -2431.74853515625,
        599.4266967773438
      ],
      [
        1393.4776611328125,
        -2433.2529296875,
        598.14892578125
      ],
      [
        1515.5496826171875,
        -2442.64794921875,
        602.534912109375
      ],
      [
        1557.8857421875,
        -2433.2529296875,
        598.1489868164062
      ],
      [
        1515.5496826171875,
        -2442.64794921875,
        602.534912109375
      ],
      [
        -172.5685577392578,
        -2447.25634765625,
        586.255126953125
      ],
      [
        -272.79998779296875,
        -2447.25634765625,
        586.255126953125
      ],
      [
        1477.2996826171875,
        -2453.685546875,
        600.75341796875
      ],
      [
        1501.3238525390625,
        -2450.46875,
        593.4994506835938
      ],
      [
        1477.2996826171875,
        -2453.685546875,
        600.75341796875
      ],
      [
        1501.3238525390625,
        -2450.46875,
        593.4994506835938
      ],
      [
        1501.32373046875,
        -2450.441162109375,
        593.4371337890625
      ],
      [
        1544.6837158203125,
        -2438.818603515625,
        593.4217529296875
      ],
      [
        1501.31396484375,
        -2447.256591796875,
        586.2549438476562
      ],
      [
        1345.52099609375,
        -2447.25634765625,
        586.255126953125
      ],
      [
        1477.2998046875,
        -2453.685546875,
        586.2454833984375
      ],
      [
        1477.2998046875,
        -2453.685546875,
        586.2454833984375
      ],
      [
        1321.548828125,
        -2491.467041015625,
        577.3600463867188
      ],
      [
        1326.3172607421875,
        -2490.189453125,
        577.359619140625
      ],
      [
        1326.317138671875,
        -2490.189453125,
        577.359619140625
      ],
      [
        1447.7935791015625,
        -2457.669677734375,
        577.41064453125
      ],
      [
        1324.033447265625,
        -2490.84228515625,
        609.546875
      ],
      [
        1321.548828125,
        -2491.5078125,
        609.5469360351562
      ],
      [
        1447.9912109375,
        -2457.642822265625,
        609.5289306640625
      ],
      [
        1324.033447265625,
        -2490.84228515625,
        609.546875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.3616013824939728,
        -0.9323328733444214
      ],
      "plane_d": 1469.2333984375,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9162540435791016,
        0.4005979001522064
      ],
      "plane_d": 2051.624755859375,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9162545204162598,
        -0.400596559047699
      ],
      "plane_d": 2527.13427734375,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.64405757188797,
        0.7649770975112915
      ],
      "plane_d": 1162.98095703125,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -567.475341796875,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.3634515106678009,
        -0.9316132068634033
      ],
      "plane_d": -325.38885498046875,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.649912416934967,
        0.6499121189117432,
        -0.3939899504184723
      ],
      "plane_d": 2881.741455078125,
      "bbox_min": [
        -210.5,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877948522567749,
        0.2378837764263153,
        0.39399445056915283
      ],
      "plane_d": 1984.919921875,
      "bbox_min": [
        -210.5,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877953886985779,
        0.23788394033908844,
        -0.3939931392669678
      ],
      "plane_d": 2452.591552734375,
      "bbox_min": [
        -210.5,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        2015.648681640625,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6385160088539124,
        0.17108990252017975,
        0.7503501772880554
      ],
      "plane_d": 1157.9024658203125,
      "bbox_min": [
        -210.5,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        2008.548828125,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36148110032081604,
        0.09685850143432617,
        -0.9273348450660706
      ],
      "plane_d": 1466.046875,
      "bbox_min": [
        -210.5,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        2008.548828125,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26462268829345703,
        0.26462268829345703,
        -0.927334725856781
      ],
      "plane_d": 1640.782470703125,
      "bbox_min": [
        -210.5,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        1991.548828125,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0969279333949089,
        -0.3617401123046875,
        -0.9272264838218689
      ],
      "plane_d": -451.95166015625,
      "bbox_min": [
        -210.5,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        1991.548828125,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26329389214515686,
        -0.26329389214515686,
        -0.9280908107757568
      ],
      "plane_d": -492.2392578125,
      "bbox_min": [
        -210.5,
        -2457.56298828125,
        567.4754638671875
      ],
      "bbox_max": [
        1991.548828125,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        -210.5,
        -2457.56298828125,
        567.4754638671875
      ],
      "bbox_max": [
        1991.548828125,
        -1804.5487060546875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09648174792528152,
        -0.3596065044403076,
        -0.9281026721000671
      ],
      "plane_d": -445.58453369140625,
      "bbox_min": [
        -210.5,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        1656.548828125,
        -2360.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2406.307373046875,
        577.501220703125
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 589.5012817382812,
      "bbox_min": [
        -210.5,
        -2406.307373046875,
        577.501220703125
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        589.5012817382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0314483642578,
      "bbox_min": [
        -210.5,
        -2406.307373046875,
        577.501220703125
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        589.5012817382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -577.501220703125,
      "bbox_min": [
        -198.0314483642578,
        -2371.5,
        577.501220703125
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 208.0314483642578,
      "bbox_min": [
        -210.5,
        -2406.307373046875,
        577.501220703125
      ],
      "bbox_max": [
        -198.0314483642578,
        -2360.5,
        589.5012817382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -577.501220703125,
      "bbox_min": [
        -210.5,
        -2371.5,
        577.501220703125
      ],
      "bbox_max": [
        -208.0314483642578,
        -2360.5,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -577.501220703125,
      "bbox_min": [
        -208.0314483642578,
        -2375.548095703125,
        577.501220703125
      ],
      "bbox_max": [
        -198.0314483642578,
        -2360.5,
        589.5012817382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2373.0,
      "bbox_min": [
        -208.0314483642578,
        -2373.0,
        577.501220703125
      ],
      "bbox_max": [
        -198.0314483642578,
        -2371.5,
        589.5012817382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        577.501220703125
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        588.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        577.501220703125
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        588.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 588.5,
      "bbox_min": [
        -207.0,
        -2373.0,
        588.5
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        588.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2386874556541443,
        -0.8896353244781494,
        -0.38932928442955017
      ],
      "plane_d": -2264.4765625,
      "bbox_min": [
        1321.548828125,
        -2457.56298828125,
        609.4441528320312
      ],
      "bbox_max": [
        1647.9989013671875,
        -2369.97705078125,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897264003753662,
        -0.23840099573135376,
        -0.38929685950279236
      ],
      "plane_d": -1949.6500244140625,
      "bbox_min": [
        1886.97705078125,
        -2130.9990234375,
        567.4754638671875
      ],
      "bbox_max": [
        1986.3671875,
        -1804.5487060546875,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6343684792518616,
        -0.16997818648815155,
        0.7541115283966064
      ],
      "plane_d": -1994.7625732421875,
      "bbox_min": [
        1928.25927734375,
        -1976.9312744140625,
        567.4754638671875
      ],
      "bbox_max": [
        1986.3671875,
        -1804.5487060546875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513238549232483,
        -0.6513241529464722,
        -0.3892994523048401
      ],
      "plane_d": -2379.727294921875,
      "bbox_min": [
        1647.772216796875,
        -2370.014404296875,
        567.4754638671875
      ],
      "bbox_max": [
        1957.47509765625,
        -1912.37548828125,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6343684792518616,
        -0.16997818648815155,
        0.7541115283966064
      ],
      "plane_d": -1994.7625732421875,
      "bbox_min": [
        1647.772216796875,
        -2370.014404296875,
        567.4754638671875
      ],
      "bbox_max": [
        1957.47509765625,
        -1912.37548828125,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2386874556541443,
        -0.8896353244781494,
        -0.38932928442955017
      ],
      "plane_d": -2264.4765625,
      "bbox_min": [
        1647.772216796875,
        -2370.014404296875,
        609.444091796875
      ],
      "bbox_max": [
        1647.9989013671875,
        -2369.956787109375,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897258043289185,
        -0.23840104043483734,
        0.38929808139801025
      ],
      "plane_d": -2411.744384765625,
      "bbox_min": [
        1880.914794921875,
        -2130.9990234375,
        577.501220703125
      ],
      "bbox_max": [
        1928.25927734375,
        -1976.9312744140625,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513234972953796,
        -0.6513237953186035,
        0.38930073380470276
      ],
      "plane_d": -2841.82470703125,
      "bbox_min": [
        1690.7982177734375,
        -2317.615478515625,
        567.4754638671875
      ],
      "bbox_max": [
        1922.656982421875,
        -2080.4091796875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6343684792518616,
        -0.16997818648815155,
        0.7541115283966064
      ],
      "plane_d": -1994.7625732421875,
      "bbox_min": [
        1880.914794921875,
        -2130.9990234375,
        567.4754638671875
      ],
      "bbox_max": [
        1912.4505615234375,
        -2080.4091796875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897258043289185,
        -0.23840104043483734,
        0.38929808139801025
      ],
      "plane_d": -2411.744384765625,
      "bbox_min": [
        1880.914794921875,
        -2130.9990234375,
        577.501220703125
      ],
      "bbox_max": [
        1893.97705078125,
        -2104.87451171875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1759.8773193359375,
        -2293.515380859375,
        567.4754638671875
      ],
      "bbox_max": [
        1922.656982421875,
        -2122.905029296875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46439480781555176,
        -0.46439507603645325,
        0.7541053295135498
      ],
      "plane_d": -2301.424560546875,
      "bbox_min": [
        1759.8773193359375,
        -2258.0986328125,
        567.4754638671875
      ],
      "bbox_max": [
        1916.50830078125,
        -2122.905029296875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6343684792518616,
        -0.16997818648815155,
        0.7541115283966064
      ],
      "plane_d": -1994.7625732421875,
      "bbox_min": [
        1886.97705078125,
        -2136.9580078125,
        567.4754638671875
      ],
      "bbox_max": [
        1901.0638427734375,
        -2122.905029296875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1823.508544921875,
        -2241.048583984375,
        567.4754638671875
      ],
      "bbox_max": [
        1916.50830078125,
        -2142.157958984375,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2386874556541443,
        -0.8896353244781494,
        -0.38932928442955017
      ],
      "plane_d": -2264.4765625,
      "bbox_min": [
        1321.548828125,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        1836.628173828125,
        -2211.834716796875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1644.4989013671875,
        -2369.956787109375,
        567.4754638671875
      ],
      "bbox_max": [
        1836.628173828125,
        -2211.834716796875,
        609.444091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513234972953796,
        -0.6513237953186035,
        0.38930073380470276
      ],
      "plane_d": -2841.82470703125,
      "bbox_min": [
        1644.4989013671875,
        -2369.956787109375,
        577.501220703125
      ],
      "bbox_max": [
        1823.508544921875,
        -2241.048583984375,
        609.444091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1644.4989013671875,
        -2369.956787109375,
        577.501220703125
      ],
      "bbox_max": [
        1823.508544921875,
        -2241.048583984375,
        609.444091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513238549232483,
        -0.6513241529464722,
        -0.3892994523048401
      ],
      "plane_d": -2379.727294921875,
      "bbox_min": [
        1644.4989013671875,
        -2369.956787109375,
        593.4994506835938
      ],
      "bbox_max": [
        1690.7982177734375,
        -2317.615478515625,
        609.444091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23796431720256805,
        -0.8878923654556274,
        0.39372605085372925
      ],
      "plane_d": -2723.91015625,
      "bbox_min": [
        1448.085693359375,
        -2416.5556640625,
        567.4754638671875
      ],
      "bbox_max": [
        1733.44921875,
        -2333.486328125,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46439480781555176,
        -0.46439507603645325,
        0.7541053295135498
      ],
      "plane_d": -2301.424560546875,
      "bbox_min": [
        1644.4989013671875,
        -2363.914794921875,
        567.4754638671875
      ],
      "bbox_max": [
        1733.44921875,
        -2333.486328125,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513234972953796,
        -0.6513237953186035,
        0.38930073380470276
      ],
      "plane_d": -2841.82470703125,
      "bbox_min": [
        1644.4989013671875,
        -2363.914794921875,
        567.4754638671875
      ],
      "bbox_max": [
        1733.44921875,
        -2333.486328125,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1714.7979736328125,
        -2338.083984375,
        567.4754638671875
      ],
      "bbox_max": [
        1733.44921875,
        -2333.486328125,
        589.0087280273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1730.7977294921875,
        -2338.083984375,
        577.501220703125
      ],
      "bbox_max": [
        1733.44921875,
        -2333.6669921875,
        589.0087280273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09643912315368652,
        0.3599158823490143,
        -0.9279870986938477
      ],
      "plane_d": 1589.833984375,
      "bbox_min": [
        1321.548828125,
        -2474.548828125,
        567.4754638671875
      ],
      "bbox_max": [
        1734.48388671875,
        -2333.664794921875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23863905668258667,
        0.8897825479507446,
        -0.3890223801136017
      ],
      "plane_d": 2769.494384765625,
      "bbox_min": [
        1448.587646484375,
        -2457.56298828125,
        567.4754638671875
      ],
      "bbox_max": [
        1734.48388671875,
        -2333.664794921875,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2378382533788681,
        0.8878090977668762,
        -0.39398977160453796
      ],
      "plane_d": 2766.45361328125,
      "bbox_min": [
        1522.7379150390625,
        -2440.57373046875,
        593.3786010742188
      ],
      "bbox_max": [
        1668.7442626953125,
        -2399.50830078125,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        1627.916015625,
        -2416.5556640625,
        593.3786010742188
      ],
      "bbox_max": [
        1668.7442626953125,
        -2405.511474609375,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1668.5718994140625,
        -2405.656982421875,
        593.3786010742188
      ],
      "bbox_max": [
        1668.7442626953125,
        -2405.511474609375,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23796431720256805,
        -0.8878923654556274,
        0.39372605085372925
      ],
      "plane_d": -2723.91015625,
      "bbox_min": [
        1448.7994384765625,
        -2416.392578125,
        567.4754638671875
      ],
      "bbox_max": [
        1734.48388671875,
        -2333.664794921875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23868732154369354,
        -0.8896347880363464,
        0.38933053612709045
      ],
      "plane_d": -2726.609130859375,
      "bbox_min": [
        1518.2481689453125,
        -2400.524658203125,
        567.4754638671875
      ],
      "bbox_max": [
        1734.48388671875,
        -2333.664794921875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46439480781555176,
        -0.46439507603645325,
        0.7541053295135498
      ],
      "plane_d": -2301.424560546875,
      "bbox_min": [
        1644.4989013671875,
        -2369.982666015625,
        567.4754638671875
      ],
      "bbox_max": [
        1734.48388671875,
        -2333.664794921875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1644.4989013671875,
        -2369.97705078125,
        567.4754638671875
      ],
      "bbox_max": [
        1734.48388671875,
        -2333.664794921875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1644.4989013671875,
        -2369.97705078125,
        577.501220703125
      ],
      "bbox_max": [
        1734.48388671875,
        -2333.759521484375,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513234972953796,
        -0.6513237953186035,
        0.38930073380470276
      ],
      "plane_d": -2841.82470703125,
      "bbox_min": [
        1644.4989013671875,
        -2369.97705078125,
        577.501220703125
      ],
      "bbox_max": [
        1667.135986328125,
        -2350.83984375,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1627.234130859375,
        -2375.548095703125,
        571.460693359375
      ],
      "bbox_max": [
        1734.48388671875,
        -2339.771728515625,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17017805576324463,
        -0.6342871785163879,
        0.7541346549987793
      ],
      "plane_d": -2219.212890625,
      "bbox_min": [
        1627.234130859375,
        -2375.548095703125,
        571.460693359375
      ],
      "bbox_max": [
        1711.6611328125,
        -2352.896240234375,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46439480781555176,
        -0.46439507603645325,
        0.7541053295135498
      ],
      "plane_d": -2301.424560546875,
      "bbox_min": [
        1647.9989013671875,
        -2370.129150390625,
        575.3298950195312
      ],
      "bbox_max": [
        1651.5194091796875,
        -2369.97705078125,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1711.08544921875,
        -2353.22998046875,
        577.3506469726562
      ],
      "bbox_max": [
        1711.6611328125,
        -2352.896240234375,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1628.760986328125,
        -2416.281982421875,
        571.5125732421875
      ],
      "bbox_max": [
        1734.4486083984375,
        -2339.80712890625,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        1628.760986328125,
        -2416.281982421875,
        571.5125732421875
      ],
      "bbox_max": [
        1711.5069580078125,
        -2353.05029296875,
        593.3926391601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1628.8983154296875,
        -2375.54833984375,
        571.5125732421875
      ],
      "bbox_max": [
        1711.5069580078125,
        -2353.05029296875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17017805576324463,
        -0.6342871785163879,
        0.7541346549987793
      ],
      "plane_d": -2219.212890625,
      "bbox_min": [
        1628.8983154296875,
        -2375.2431640625,
        575.3870239257812
      ],
      "bbox_max": [
        1651.2801513671875,
        -2370.10693359375,
        577.3822021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46439480781555176,
        -0.46439507603645325,
        0.7541053295135498
      ],
      "plane_d": -2301.424560546875,
      "bbox_min": [
        1648.0738525390625,
        -2371.573486328125,
        575.3870239257812
      ],
      "bbox_max": [
        1651.2801513671875,
        -2370.10693359375,
        577.3750610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6473601460456848,
        0.7621843218803406
      ],
      "plane_d": -2031.0906982421875,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        1698.6129150390625,
        -2349.849853515625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17090743780136108,
        -0.6378357410430908,
        0.7509702444076538
      ],
      "plane_d": -2227.0703125,
      "bbox_min": [
        -272.79998779296875,
        -2469.3671875,
        567.475341796875
      ],
      "bbox_max": [
        1698.6129150390625,
        -2349.849853515625,
        599.4266967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17017805576324463,
        -0.6342871785163879,
        0.7541346549987793
      ],
      "plane_d": -2219.212890625,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        567.4754638671875
      ],
      "bbox_max": [
        1698.6129150390625,
        -2349.849853515625,
        597.5145263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -577.501220703125,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        567.4754638671875
      ],
      "bbox_max": [
        1698.6129150390625,
        -2349.849853515625,
        597.5145263671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.46439480781555176,
        -0.46439507603645325,
        0.7541053295135498
      ],
      "plane_d": -2301.424560546875,
      "bbox_min": [
        1648.920654296875,
        -2380.29833984375,
        567.4754638671875
      ],
      "bbox_max": [
        1698.6129150390625,
        -2349.849853515625,
        575.9505615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1673.3646240234375,
        -2375.098388671875,
        567.4754638671875
      ],
      "bbox_max": [
        1698.6129150390625,
        -2349.849853515625,
        572.7591552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2434.0,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        -172.5685577392578,
        -2375.548095703125,
        597.5145263671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0314483642578,
      "bbox_min": [
        -208.0314483642578,
        -2434.0,
        577.501220703125
      ],
      "bbox_max": [
        -198.0314483642578,
        -2375.548095703125,
        589.5012817382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 208.0314483642578,
      "bbox_min": [
        -208.0314483642578,
        -2434.0,
        577.501220703125
      ],
      "bbox_max": [
        -198.0314483642578,
        -2375.548095703125,
        589.5012817382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 589.5012817382812,
      "bbox_min": [
        -208.0314483642578,
        -2434.0,
        589.5012817382812
      ],
      "bbox_max": [
        -198.0314483642578,
        -2406.307373046875,
        589.5012817382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 272.79998779296875,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        -172.5685577392578,
        -2434.0,
        597.5145263671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -172.5685577392578,
      "bbox_min": [
        -172.5685577392578,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        -172.5685577392578,
        -2434.0,
        597.5145263671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.23868732154369354,
        -0.8896347880363464,
        0.38933053612709045
      ],
      "plane_d": -2726.609130859375,
      "bbox_min": [
        1321.548828125,
        -2457.56298828125,
        567.4754638671875
      ],
      "bbox_max": [
        1693.5513916015625,
        -2363.39306640625,
        577.6448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1673.3646240234375,
        -2375.098388671875,
        567.4754638671875
      ],
      "bbox_max": [
        1693.5513916015625,
        -2363.39306640625,
        572.78076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16998730599880219,
        0.634684145450592,
        0.7538437843322754
      ],
      "plane_d": 1370.701904296875,
      "bbox_min": [
        1321.548828125,
        -2469.3671875,
        567.475341796875
      ],
      "bbox_max": [
        1693.53076171875,
        -2363.448486328125,
        599.4266967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23868732154369354,
        -0.8896347880363464,
        0.38933053612709045
      ],
      "plane_d": -2726.609130859375,
      "bbox_min": [
        1321.548828125,
        -2461.086669921875,
        567.4754638671875
      ],
      "bbox_max": [
        1693.53076171875,
        -2363.448486328125,
        599.4266967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23796431720256805,
        -0.8878923654556274,
        0.39372605085372925
      ],
      "plane_d": -2723.91015625,
      "bbox_min": [
        1321.548828125,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        1518.2481689453125,
        -2400.524658203125,
        593.5902099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23796449601650238,
        -0.8878929615020752,
        -0.3937245309352875
      ],
      "plane_d": -2256.560546875,
      "bbox_min": [
        1365.359375,
        -2438.72705078125,
        593.4994506835938
      ],
      "bbox_max": [
        1448.085693359375,
        -2416.5556640625,
        593.5902099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17123213410377502,
        0.638451099395752,
        0.7503730654716492
      ],
      "plane_d": 1383.7373046875,
      "bbox_min": [
        1365.9083251953125,
        -2461.086669921875,
        567.4754638671875
      ],
      "bbox_max": [
        1693.53076171875,
        -2363.448486328125,
        599.4266967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23863889276981354,
        0.8897818922996521,
        0.38902392983436584
      ],
      "plane_d": 2307.72265625,
      "bbox_min": [
        1365.9083251953125,
        -2457.56298828125,
        567.4754638671875
      ],
      "bbox_max": [
        1693.53076171875,
        -2363.448486328125,
        599.4266967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        1495.9892578125,
        -2448.29248046875,
        577.501220703125
      ],
      "bbox_max": [
        1667.578125,
        -2399.50830078125,
        593.6055297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2378382533788681,
        0.8878090977668762,
        -0.39398977160453796
      ],
      "plane_d": 2766.45361328125,
      "bbox_min": [
        1545.1539306640625,
        -2438.72705078125,
        577.501220703125
      ],
      "bbox_max": [
        1667.578125,
        -2399.50830078125,
        593.6055297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1665.048828125,
        -2403.734619140625,
        577.501220703125
      ],
      "bbox_max": [
        1667.578125,
        -2399.50830078125,
        588.49755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2378382533788681,
        0.8878090977668762,
        -0.39398977160453796
      ],
      "plane_d": 2766.45361328125,
      "bbox_min": [
        1365.9083251953125,
        -2438.6357421875,
        567.4754638671875
      ],
      "bbox_max": [
        1693.53076171875,
        -2363.448486328125,
        599.4266967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4674248695373535,
        0.4674248695373535,
        0.7503520250320435
      ],
      "plane_d": 1466.5458984375,
      "bbox_min": [
        1659.157958984375,
        -2399.50830078125,
        567.4754638671875
      ],
      "bbox_max": [
        1693.53076171875,
        -2363.448486328125,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.914152979850769,
        -0.40536949038505554
      ],
      "plane_d": -1999.516845703125,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        1561.384521484375,
        -2431.74853515625,
        616.1244506835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.42300987243652344,
        -0.9061251282691956
      ],
      "plane_d": -487.292236328125,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        586.2549438476562
      ],
      "bbox_max": [
        1561.384521484375,
        -2431.74853515625,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23796449601650238,
        -0.8878929615020752,
        -0.3937245309352875
      ],
      "plane_d": -2256.560546875,
      "bbox_min": [
        1321.548828125,
        -2457.56298828125,
        598.14892578125
      ],
      "bbox_max": [
        1561.384521484375,
        -2431.74853515625,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23863905668258667,
        0.8897825479507446,
        -0.3890223801136017
      ],
      "plane_d": 2769.494384765625,
      "bbox_min": [
        1448.587646484375,
        -2457.56298828125,
        598.1489868164062
      ],
      "bbox_max": [
        1561.384521484375,
        -2431.74853515625,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2378382533788681,
        0.8878090977668762,
        -0.39398977160453796
      ],
      "plane_d": 2766.45361328125,
      "bbox_min": [
        1515.5496826171875,
        -2442.64794921875,
        598.1489868164062
      ],
      "bbox_max": [
        1561.384521484375,
        -2431.74853515625,
        602.8696899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23796449601650238,
        -0.8878929615020752,
        -0.3937245309352875
      ],
      "plane_d": -2256.560546875,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        586.2549438476562
      ],
      "bbox_max": [
        1557.8857421875,
        -2433.2529296875,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2434.0,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        586.255126953125
      ],
      "bbox_max": [
        -172.5685577392578,
        -2434.0,
        609.4977416992188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -172.5685577392578,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        586.255126953125
      ],
      "bbox_max": [
        -172.5685577392578,
        -2434.0,
        609.4977416992188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 272.79998779296875,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        586.255126953125
      ],
      "bbox_max": [
        -272.79998779296875,
        -2434.0,
        609.4977416992188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.23863905668258667,
        0.8897825479507446,
        -0.3890223801136017
      ],
      "plane_d": 2769.494384765625,
      "bbox_min": [
        1321.548828125,
        -2457.56298828125,
        586.2549438476562
      ],
      "bbox_max": [
        1557.8857421875,
        -2433.2529296875,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2378382533788681,
        0.8878090977668762,
        -0.39398977160453796
      ],
      "plane_d": 2766.45361328125,
      "bbox_min": [
        1477.2996826171875,
        -2453.685546875,
        593.4217529296875
      ],
      "bbox_max": [
        1557.8857421875,
        -2433.2529296875,
        602.534912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        1501.32373046875,
        -2450.46875,
        593.4217529296875
      ],
      "bbox_max": [
        1545.1539306640625,
        -2438.72705078125,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        1321.548828125,
        -2450.46875,
        586.2549438476562
      ],
      "bbox_max": [
        1544.6837158203125,
        -2438.72705078125,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23796431720256805,
        -0.8878923654556274,
        0.39372605085372925
      ],
      "plane_d": -2723.91015625,
      "bbox_min": [
        1321.548828125,
        -2450.46875,
        586.255126953125
      ],
      "bbox_max": [
        1365.359375,
        -2438.72705078125,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9141523838043213,
        0.4053707718849182
      ],
      "plane_d": -2480.689208984375,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        1501.3238525390625,
        -2447.25634765625,
        616.1244506835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.23863889276981354,
        0.8897818922996521,
        0.38902392983436584
      ],
      "plane_d": 2307.72265625,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        1501.3238525390625,
        -2447.25634765625,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        1477.2998046875,
        -2453.685546875,
        585.3750610351562
      ],
      "bbox_max": [
        1501.3238525390625,
        -2447.256591796875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23796431720256805,
        -0.8878923654556274,
        0.39372605085372925
      ],
      "plane_d": -2723.91015625,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        1345.52099609375,
        -2447.25634765625,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 272.79998779296875,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        -172.5685577392578,
        -2447.25634765625,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -172.5685577392578,
      "bbox_min": [
        -172.5685577392578,
        -2457.56298828125,
        577.501220703125
      ],
      "bbox_max": [
        -172.5685577392578,
        -2447.25634765625,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        1501.3238525390625,
        -2450.46875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23863889276981354,
        0.8897818922996521,
        0.38902392983436584
      ],
      "plane_d": 2307.72265625,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        577.359619140625
      ],
      "bbox_max": [
        1477.2998046875,
        -2453.685546875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17123213410377502,
        0.638451099395752,
        0.7503730654716492
      ],
      "plane_d": 1383.7373046875,
      "bbox_min": [
        1321.548828125,
        -2491.634765625,
        577.359619140625
      ],
      "bbox_max": [
        1448.5880126953125,
        -2457.56298828125,
        577.501220703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2378382533788681,
        0.8878090977668762,
        -0.39398977160453796
      ],
      "plane_d": 2766.45361328125,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        1501.3238525390625,
        -2450.46875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23863905668258667,
        0.8897825479507446,
        -0.3890223801136017
      ],
      "plane_d": 2769.494384765625,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        593.4994506835938
      ],
      "bbox_max": [
        1477.2996826171875,
        -2453.685546875,
        609.5469360351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09693778306245804,
        0.3614393472671509,
        -0.9273427128791809
      ],
      "plane_d": 1593.896240234375,
      "bbox_min": [
        1321.548828125,
        -2491.634765625,
        609.4977416992188
      ],
      "bbox_max": [
        1448.587646484375,
        -2457.56298828125,
        609.5469360351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.17123213410377502,
        0.638451099395752,
        0.7503730654716492
      ],
      "plane_d": 1383.7373046875,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        1447.9912109375,
        -2450.46875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 372.7999572753906,
      "bbox_min": [
        -372.79998779296875,
        -2498.62939453125,
        567.475341796875
      ],
      "bbox_max": [
        -372.79998779296875,
        -2450.46875,
        616.1244506835938
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: datapoly",
      "entity_class": "CSlidingDoor",
      "piece_name": "datapoly",
      "offset": 1901,
      "centroid": [
        -203.0314483642578,
        -2403.5,
        577.5047607421875
      ],
      "bbox_min": [
        -208.0314483642578,
        -2434.0,
        577.5047607421875
      ],
      "bbox_max": [
        -198.0314483642578,
        -2373.0,
        577.5047607421875
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 61.0,
        "height_z": 0.0,
        "door_width": 61.0,
        "door_depth": 10.0,
        "leaf_depth": 9.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -198.0314483642578,
          -2434.0,
          577.5047607421875
        ],
        [
          -208.0314483642578,
          -2434.0,
          577.5047607421875
        ],
        [
          -208.0314483642578,
          -2373.0,
          577.5047607421875
        ],
        [
          -198.0314483642578,
          -2373.0,
          577.5047607421875
        ]
      ],
      "plane_distance": -577.5048,
      "authentic_texture": "chkcemt-d_h"
    }
  ],
  "tutorial_messages": []
}